import type { FetchFunction } from 'relay-runtime';

type GraphQLRequest = {
  text?: string | null;
};

const getToken = (): string | null => {
  try {
    return localStorage.getItem('console_token');
  } catch {
    return null;
  }
};

const handleAuthError = () => {
  window.dispatchEvent(new CustomEvent('session-expired'));
};

const hasAuthError = (json: any): boolean => {
  const errors = json?.errors;
  if (!errors || !Array.isArray(errors)) return false;
  return errors.some((error) => error?.message === 'Forbidden');
};

export const fetchGraphQL: FetchFunction = async (params: GraphQLRequest, variables) => {
  const endpoint = process.env.GRAPHQL_ENDPOINT || '/graphql';
  const token = getToken();

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ query: params.text, variables }),
  });

  const json = await response.json();

  if (hasAuthError(json)) {
    handleAuthError();
    throw new Error('Forbidden');
  }

  return json;
};
